const data = [
    {
        id: "1",
        iconSrc: "/images/file-icons/zip.png",
        title: "UX/UI Templates",
        files: "2,478 FILES",
        members: {
            total_user: "862+ members recently access",
            user_list: [
                {
                    id: 1,
                    user_name: "Janette Dalton",
                    user_img: "/images/avatar/2.png"
                },
                {
                    id: 2,
                    user_name: "Mikal Bon",
                    user_img: "/images/avatar/3.png"
                },
                {
                    id: 3,
                    user_name: "Socrates Itumay",
                    user_img: "/images/avatar/4.png"
                },
                {
                    id: 4,
                    user_name: "Jakson Jak",
                    user_img: "/images/avatar/6.png"
                },
            ]
        },
    },
    {
        id: "2",
        iconSrc: "/images/file-icons/png.png",
        title: "UX/UI Templates",
        files: "2,478 FILES",
        members: {
            total_user: "862+ members recently access",
            user_list: [
                {
                    id: 1,
                    user_name: "Janette Dalton",
                    user_img: "/images/avatar/2.png"
                },
                {
                    id: 2,
                    user_name: "Mikal Bon",
                    user_img: "/images/avatar/3.png"
                },
                {
                    id: 3,
                    user_name: "Socrates Itumay",
                    user_img: "/images/avatar/4.png"
                },
                {
                    id: 4,
                    user_name: "Jakson Jak",
                    user_img: "/images/avatar/6.png"
                },
            ]
        },
    },
    {
        id: "3",
        iconSrc: "/images/file-icons/pdf.png",
        title: "UX/UI Templates",
        files: "2,478 FILES",
        members: {
            total_user: "862+ members recently access",
            user_list: [
                {
                    id: 1,
                    user_name: "Janette Dalton",
                    user_img: "/images/avatar/2.png"
                },
                {
                    id: 2,
                    user_name: "Mikal Bon",
                    user_img: "/images/avatar/3.png"
                },
                {
                    id: 3,
                    user_name: "Socrates Itumay",
                    user_img: "/images/avatar/4.png"
                },
                {
                    id: 4,
                    user_name: "Jakson Jak",
                    user_img: "/images/avatar/6.png"
                },
            ]
        },
    },
    {
        id: "4",
        iconSrc: "/images/file-icons/psd.png",
        title: "UX/UI Templates",
        files: "2,478 FILES",
        members: {
            total_user: "862+ members recently access",
            user_list: [
                {
                    id: 1,
                    user_name: "Janette Dalton",
                    user_img: "/images/avatar/2.png"
                },
                {
                    id: 2,
                    user_name: "Mikal Bon",
                    user_img: "/images/avatar/3.png"
                },
                {
                    id: 3,
                    user_name: "Socrates Itumay",
                    user_img: "/images/avatar/4.png"
                },
                {
                    id: 4,
                    user_name: "Jakson Jak",
                    user_img: "/images/avatar/6.png"
                },
            ]
        },
    },
    {
        id: "5",
        iconSrc: "/images/file-icons/zip.png",
        title: "UX/UI Templates",
        files: "2,478 FILES",
        members: {
            total_user: "862+ members recently access",
            user_list: [
                {
                    id: 1,
                    user_name: "Janette Dalton",
                    user_img: "/images/avatar/2.png"
                },
                {
                    id: 2,
                    user_name: "Mikal Bon",
                    user_img: "/images/avatar/3.png"
                },
                {
                    id: 3,
                    user_name: "Socrates Itumay",
                    user_img: "/images/avatar/4.png"
                },
                {
                    id: 4,
                    user_name: "Jakson Jak",
                    user_img: "/images/avatar/6.png"
                },
            ]
        },
    },
    {
        id: "6",
        iconSrc: "/images/file-icons/png.png",
        title: "UX/UI Templates",
        files: "2,478 FILES",
        members: {
            total_user: "862+ members recently access",
            user_list: [
                {
                    id: 1,
                    user_name: "Janette Dalton",
                    user_img: "/images/avatar/2.png"
                },
                {
                    id: 2,
                    user_name: "Mikal Bon",
                    user_img: "/images/avatar/3.png"
                },
                {
                    id: 3,
                    user_name: "Socrates Itumay",
                    user_img: "/images/avatar/4.png"
                },
                {
                    id: 4,
                    user_name: "Jakson Jak",
                    user_img: "/images/avatar/6.png"
                },
            ]
        },
    },
    {
        id: "7",
        iconSrc: "/images/file-icons/pdf.png",
        title: "UX/UI Templates",
        files: "2,478 FILES",
        members: {
            total_user: "862+ members recently access",
            user_list: [
                {
                    id: 1,
                    user_name: "Janette Dalton",
                    user_img: "/images/avatar/2.png"
                },
                {
                    id: 2,
                    user_name: "Mikal Bon",
                    user_img: "/images/avatar/3.png"
                },
                {
                    id: 3,
                    user_name: "Socrates Itumay",
                    user_img: "/images/avatar/4.png"
                },
                {
                    id: 4,
                    user_name: "Jakson Jak",
                    user_img: "/images/avatar/6.png"
                },
            ]
        },
    },
    {
        id: "8",
        iconSrc: "/images/file-icons/psd.png",
        title: "UX/UI Templates",
        files: "2,478 FILES",
        members: {
            total_user: "862+ members recently access",
            user_list: [
                {
                    id: 1,
                    user_name: "Janette Dalton",
                    user_img: "/images/avatar/2.png"
                },
                {
                    id: 2,
                    user_name: "Mikal Bon",
                    user_img: "/images/avatar/3.png"
                },
                {
                    id: 3,
                    user_name: "Socrates Itumay",
                    user_img: "/images/avatar/4.png"
                },
                {
                    id: 4,
                    user_name: "Jakson Jak",
                    user_img: "/images/avatar/6.png"
                },
            ]
        },
    },
]


export const storageFolderData = (srartIndex = 0, endIndex = data.length) => {
    return data.slice(srartIndex, endIndex)
}

export const storageProjectData = [
    {
        id: "1",
        iconSrc: "/images/file-icons/html.png",
        title: "HTML5 Webpages - V2.3.4",
        fileSIze: "	5.34 MB",
        uploadDate: "25 March, 2023",
        members: {
            total_user: "862+ members",
            user_list: [
                {
                    id: 1,
                    user_name: "Janette Dalton",
                    user_img: "/images/avatar/2.png"
                },
                {
                    id: 2,
                    user_name: "Mikal Bon",
                    user_img: "/images/avatar/3.png"
                },
                {
                    id: 3,
                    user_name: "Socrates Itumay",
                    user_img: "/images/avatar/4.png"
                },
                {
                    id: 4,
                    user_name: "Jakson Jak",
                    user_img: "/images/avatar/6.png"
                },
            ]
        },
    },
    {
        id: "2",
        iconSrc: "/images/file-icons/css.png",
        title: "CSS3 Stylesheeth - V2.1.4",
        fileSIze: "	2.67 MB",
        uploadDate: "20 March, 2023",
        members: {
            total_user: "862+ members",
            user_list: [
                {
                    id: 1,
                    user_name: "Janette Dalton",
                    user_img: "/images/avatar/2.png"
                },
                {
                    id: 2,
                    user_name: "Mikal Bon",
                    user_img: "/images/avatar/3.png"
                },
                {
                    id: 3,
                    user_name: "Socrates Itumay",
                    user_img: "/images/avatar/4.png"
                },
                {
                    id: 4,
                    user_name: "Jakson Jak",
                    user_img: "/images/avatar/6.png"
                },
            ]
        },
    },
    {
        id: "3",
        iconSrc: "/images/file-icons/pdf.png",
        title: "PDF Documentations - V3.2.1",
        fileSIze: "2.85 MB",
        uploadDate: "20 March, 2023",
        members: {
            total_user: "862+ members",
            user_list: [
                {
                    id: 1,
                    user_name: "Janette Dalton",
                    user_img: "/images/avatar/2.png"
                },
                {
                    id: 2,
                    user_name: "Mikal Bon",
                    user_img: "/images/avatar/3.png"
                },
                {
                    id: 3,
                    user_name: "Socrates Itumay",
                    user_img: "/images/avatar/4.png"
                },
                {
                    id: 4,
                    user_name: "Jakson Jak",
                    user_img: "/images/avatar/6.png"
                },
            ]
        },
    },
    {
        id: "4",
        iconSrc: "/images/file-icons/html.png",
        title: "HTML5 Webpages - V2.3.4",
        fileSIze: "	5.34 MB",
        uploadDate: "25 March, 2023",
        members: {
            total_user: "862+ members",
            user_list: [
                {
                    id: 1,
                    user_name: "Janette Dalton",
                    user_img: "/images/avatar/2.png"
                },
                {
                    id: 2,
                    user_name: "Mikal Bon",
                    user_img: "/images/avatar/3.png"
                },
                {
                    id: 3,
                    user_name: "Socrates Itumay",
                    user_img: "/images/avatar/4.png"
                },
                {
                    id: 4,
                    user_name: "Jakson Jak",
                    user_img: "/images/avatar/6.png"
                },
            ]
        },
    },
    {
        id: "5",
        iconSrc: "/images/file-icons/css.png",
        title: "CSS3 Stylesheeth - V2.1.4",
        fileSIze: "	2.67 MB",
        uploadDate: "20 March, 2023",
        members: {
            total_user: "862+ members",
            user_list: [
                {
                    id: 1,
                    user_name: "Janette Dalton",
                    user_img: "/images/avatar/2.png"
                },
                {
                    id: 2,
                    user_name: "Mikal Bon",
                    user_img: "/images/avatar/3.png"
                },
                {
                    id: 3,
                    user_name: "Socrates Itumay",
                    user_img: "/images/avatar/4.png"
                },
                {
                    id: 4,
                    user_name: "Jakson Jak",
                    user_img: "/images/avatar/6.png"
                },
            ]
        },
    },
    {
        id: "6",
        iconSrc: "/images/file-icons/pdf.png",
        title: "PDF Documentations - V3.2.1",
        fileSIze: "2.85 MB",
        uploadDate: "20 March, 2023",
        members: {
            total_user: "862+ members",
            user_list: [
                {
                    id: 1,
                    user_name: "Janette Dalton",
                    user_img: "/images/avatar/2.png"
                },
                {
                    id: 2,
                    user_name: "Mikal Bon",
                    user_img: "/images/avatar/3.png"
                },
                {
                    id: 3,
                    user_name: "Socrates Itumay",
                    user_img: "/images/avatar/4.png"
                },
                {
                    id: 4,
                    user_name: "Jakson Jak",
                    user_img: "/images/avatar/6.png"
                },
            ]
        },
    },
    {
        id: "7",
        iconSrc: "/images/file-icons/html.png",
        title: "HTML5 Webpages - V2.3.4",
        fileSIze: "	5.34 MB",
        uploadDate: "25 March, 2023",
        members: {
            total_user: "862+ members",
            user_list: [
                {
                    id: 1,
                    user_name: "Janette Dalton",
                    user_img: "/images/avatar/2.png"
                },
                {
                    id: 2,
                    user_name: "Mikal Bon",
                    user_img: "/images/avatar/3.png"
                },
                {
                    id: 3,
                    user_name: "Socrates Itumay",
                    user_img: "/images/avatar/4.png"
                },
                {
                    id: 4,
                    user_name: "Jakson Jak",
                    user_img: "/images/avatar/6.png"
                },
            ]
        },
    },
    {
        id: "8",
        iconSrc: "/images/file-icons/css.png",
        title: "CSS3 Stylesheeth - V2.1.4",
        fileSIze: "	2.67 MB",
        uploadDate: "20 March, 2023",
        members: {
            total_user: "862+ members",
            user_list: [
                {
                    id: 1,
                    user_name: "Janette Dalton",
                    user_img: "/images/avatar/2.png"
                },
                {
                    id: 2,
                    user_name: "Mikal Bon",
                    user_img: "/images/avatar/3.png"
                },
                {
                    id: 3,
                    user_name: "Socrates Itumay",
                    user_img: "/images/avatar/4.png"
                },
                {
                    id: 4,
                    user_name: "Jakson Jak",
                    user_img: "/images/avatar/6.png"
                },
            ]
        },
    },
]

export const cloudStorageData = [
    {
        id: "1",
        iconSrc: "/images/storage-icons/local-storage.png",
        name: "Local Storage",
        used: '286.45',
        total: '500.00',
        lastActivity: "36 Mins Ago",
        progressColor: "bg-warning"
    },
    {
        id: "2",
        iconSrc: "/images/storage-icons/dropbox.png",
        name: "Dropbox Storage",
        used: '5.68',
        total: '15.00',
        lastActivity: "3 Hours Ago",
        progressColor: "bg-texl"
    },
    {
        id: "3",
        iconSrc: "/images/storage-icons/google-drive.png",
        name: "Google Drive",
        used: '4.75',
        total: '10.00',
        lastActivity: "5 Hours Ago",
        progressColor: "bg-danger"
    },
    {
        id: "4",
        iconSrc: "/images/storage-icons/box.png",
        name: "Box Storage",
        used: '3.64',
        total: '10.00',
        lastActivity: "26 Aug, 2022",
        progressColor: "bg-teal"
    },

]